import { ProviderRepo } from "@services/fileprovider.repo";
import * as _ from "lodash";
import { FileItem } from "@models/fileprovider/FileItem";

class newFileController implements angular.IOnInit {
  public selectedUsername: string;
  public password: string;
  public isLoading = false;
  public showpassword = false;
  public file: FileItem;

  /** @ngInject */
  constructor(
    private fileRepo: ProviderRepo,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any
  ) {}

  $onInit() {}

  saveFile() {
    this.isLoading = true;
    this.fileRepo
      .createFile(this.selectedUsername, this.file)
      .catch((err) => this.notifyjs(err))
      .finally(() => {
        this.isLoading = false;
        this.selectedUsername = undefined;
        this.password = "";
        this.$state.go("root.fileproviders");
      });
  }

  //TODO: Implement cancel/back button
  cancelFileEdit() {
    this.selectedUsername = undefined;
    this.password = "";
    this.$state.go("root.fileproviders");
  }
}

export const newFile: angular.IComponentOptions = {
  template: require("./newFile.html"),
  controller: newFileController,
  bindings: {
    selectedUsername: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/fileprovider/newFile/newFile.ts